var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui dimmer",class:{ inverted: _vm.inverted, active: _vm.dimmed }},[_vm._t("default",[(_vm.dimmed)?_c('loader',{attrs:{"active":_vm.dimmed}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }